import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import {
  CheckboxTemplate,
  Expanded,
  ExpandedBlock,
  GroupTitleTemplate,
  RadioGroupTemplate,
} from "@ryde/controls";
import { BOOKING_ADD_NEW_FORM_FIELDS } from "@ryde/shared";

import { BulkCreateBookingsRadioCheckboxStyled } from "./bulk-bookings.styled";
import { useBulkBookingConflictsForm } from "./hooks";

export const BulkConflictsSection = (): ReactNode => {
  const { t } = useTranslation();

  const {
    // createIfExistingFormAttributes, // RYDE-7139: removed with the "existing ride" radio (see commented block below)
    createIfInsideFormAttributes,
    createIfOverlapFormAttributes,
    createIfIneligibleFormAttributes,
  } = useBulkBookingConflictsForm();

  return (
    <Expanded
      NavControl={
        <GroupTitleTemplate
          name="conflicts"
          formLabel={t(`booking.formLabel.conflicts`)}
          formIcon={
            <SVG_MUI.TriangleExclamationSVG
              width={20}
              height={20}
              style={{ marginInlineEnd: "5px" }}
            />
          }
        />
      }
    >
      <ExpandedBlock>
        {/*
          RYDE-7139: the "Booking conflicts with an existing ride" selection was removed from the
          Conflicts section per the PRD — it is superseded by the top-level "Update" (Replace existing
          bookings) checkbox. Please keep this commented block — the replacement is still under
          testing/validation, so do not delete it. To restore, also uncomment `createIfExistingFormAttributes`
          in use-bulk-booking-conflicts-form.ts and `conflicts.createIfExisting` in the panel payload.
          <RadioGroupTemplate
            name={BOOKING_ADD_NEW_FORM_FIELDS.conflictsDetailsCreateIfExisting}
            labelTranslated={t("booking.formLabel.conflictsDetails.createIfExisting")}
            formAttributes={createIfExistingFormAttributes}
          />
        */}
        <RadioGroupTemplate
          name={BOOKING_ADD_NEW_FORM_FIELDS.conflictsDetailsCreateIfInside}
          labelTranslated={t(
            "booking.formLabel.conflictsDetails.createIfInside",
          )}
          formAttributes={createIfInsideFormAttributes}
        />
        <RadioGroupTemplate
          name={BOOKING_ADD_NEW_FORM_FIELDS.conflictsDetailsCreateIfOverlap}
          labelTranslated={t(
            "booking.formLabel.conflictsDetails.createIfOverlap",
          )}
          formAttributes={createIfOverlapFormAttributes}
        />
        <BulkCreateBookingsRadioCheckboxStyled>
          <CheckboxTemplate
            name={BOOKING_ADD_NEW_FORM_FIELDS.conflictsDetailsCreateIfGap}
            labelTranslated={t(
              "booking.formLabel.conflictsDetails.createIfGap",
            )}
          />
        </BulkCreateBookingsRadioCheckboxStyled>
        <RadioGroupTemplate
          name={BOOKING_ADD_NEW_FORM_FIELDS.conflictsDetailsCreateIfIneligible}
          labelTranslated={t(
            "booking.formLabel.conflictsDetails.createIfIneligible",
          )}
          formAttributes={createIfIneligibleFormAttributes}
        />
      </ExpandedBlock>
    </Expanded>
  );
};
